import React, { Component } from "react";
import { injectIntl } from 'react-intl';
import cx from 'classnames'

import Routes from 'src/app/routes'
import {
  hasLocalStorage,
  getBodyContainer,
  getCurrentPageUrlInfo,
  getParamFromUrlWithoutRouter,
  getPageClassFromUrl,
} from 'src/utils/helpers'
import PushService from 'src/utils/push-service'
import EventsService from 'src/utils/events-service'
import notification from 'src/components/Notification'
import { Layout, Sidebar, Content, Container } from 'src/components/Layout'
import HeaderMain from 'src/components/Layout/Header/HeaderMain'
import OfflineStatus from 'src/modules/OfflineStatus'
import AddToHomeScreen from 'src/modals/AddToHomeScreen'
import NetworkProvider from 'src/components/NetworkProvider'
import IdleDetect from 'src/components/Events/IdleDetect'
import IdleLogOut from 'src/components/Events/IdleLogOut'
import NotificationBanner from "src/components/NotificationBanner"
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from './translations'

import styles from './AppLayout.module.less'

class AppLayout extends Component {


  componentDidMount() {
    const { setIsWidget, featureFlags, isWidget, user, location, setDisclaimer, bannerNotification } = this.props
    setDisclaimer(true)
    setIsWidget(isWidget)
    if (PushService.isEnabled('chat', user, featureFlags, isWidget)) {
      // Just sync existing subscription
      PushService.updatePushSubscription(true, isWidget)
    }

    if (!isWidget) {
      const loginFromLinkReferrer = getParamFromUrlWithoutRouter(location, 4, null)

      // Wait until everything is settled and someone is actually visiting the page
      // Useful for waiting to see current access type
      setTimeout(() => {
        const { userLastAccessType } = this.props

        // Take "loginFromLinkReferrer" if set because we can find that from URL right away,
        // where "userLastAccessType" takes time to be set from EmailVerification.componentDidMount
        const accessType = loginFromLinkReferrer || userLastAccessType

        const visitEventType = accessType === 'logInAsKioskUserLink' ? 'visitAsKioskUser' : 'visit'

        EventsService.registerEvent({ isWidget }, 'access', visitEventType)

      }, 3000)
    }

    const currentPageClass = getPageClassFromUrl(location.pathname)
    this.addClassBody(currentPageClass)
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props

    if (location.pathname !== prevProps.location.pathname) {
      const prevPageClass = getPageClassFromUrl(prevProps.location.pathname)
      this.removeClassBody(prevPageClass)
  
      const currentPageClass = getPageClassFromUrl(location.pathname)
      this.addClassBody(currentPageClass)
    }
  }

  addClassBody(cls) {
    document.body.classList.add(cls)
  }

  removeClassBody(cls) {
    document.body.classList.remove(cls)
  }

  render() {

    const {
      setRenderedAppState,
      currentlyOpenFeature,
      isSidebarVisible,
      isWidget,
      isWidgetActive,
      isWidgetFullSize,
      location,
      intl,
      bannerNotification
    } = this.props

    if (!hasLocalStorage()) {
      notification.error({
        message: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessages.appCookiesRequiredMessage),
        duration: 0,
        getContainer: () => getBodyContainer(),
      })

      return null
    }
    const currentPageCls = getCurrentPageUrlInfo(location, 'cls')

    // TODO: Converted to modular CSS

    const classNamesLayout = 'kiosk-first-layout '
      + currentPageCls
      + (currentlyOpenFeature ? ' ' + currentlyOpenFeature : '')
      + ' is-widget-' + (isWidget ? 'yes' : 'no')

    const classNamesAppMainLayout = cx({
      [styles.appMainLayout]: true,
      [styles.appMainLayoutOpenSidebarOnMobile]: isSidebarVisible === true,
      'app-main-layout': true,
    })

    const classNamesAppMainContainerInner = cx({
      [styles.mainContainerInner]: true,
      [styles.mainContainerInnerHeightFull]: currentPageCls && currentPageCls.includes('chat'),
      [styles.mainContainerInnerHeightAuto]: currentPageCls && currentPageCls.includes('requestQuote'),
      'app-main-container-inner': true,
    })

    return (
      <Layout className={classNamesLayout}>
        {!isWidget ? (
          <React.Fragment>
            <NetworkProvider />
            <AddToHomeScreen />
            <OfflineStatus />
          </React.Fragment>
        ) : ''}
        <Layout className={classNamesAppMainLayout} hasSider={true}>
          <IdleDetect />
          <IdleLogOut />
          <HeaderMain
            isWidget={!!isWidget}
            isWidgetActive={!!isWidgetActive}
            isWidgetFullSize={!!isWidgetFullSize}
            isHome={currentPageCls && currentPageCls.includes('home')}
          />
          <Sidebar />
          <Content className="app-main-content" isInner={false}>
            <Container className="app-main-container">
              <NotificationBanner
                className={styles.displayingNotification}
                bannerNotification={bannerNotification}
              />
              <div className={classNamesAppMainContainerInner}>
                <Routes rendered={setRenderedAppState} />
              </div>
            </Container>
          </Content>
        </Layout>
      </Layout>
    )
  }
}

export default injectIntl(AppLayout)
